/* eslint-disable camelcase */

import { useLocation } from 'react-router';
import { getPostAuthorizeParams } from './authorize-utils';

function _getAdditionalScopes(requestedScope) {
  const scopeMappingObject = window._AthenaIdentityScopeMapping;
  if (!scopeMappingObject) {
    return [];
  }
  const scopeMappingKeys = Object.keys(scopeMappingObject);
  if (scopeMappingKeys.includes(requestedScope)) {
    return scopeMappingObject[requestedScope];
  }
  return [];
}

// For Authorize POST method call this from preAuthorize.js directly to add
// HTI1 scopes
export function addHTI1Scopes (requestedScopes) {
  const requestedupdatedScopesArray = requestedScopes.split(' ');
  const scopesArray = [];
  requestedupdatedScopesArray.forEach(requestedScope => {
    const addScopes = _getAdditionalScopes(requestedScope);
    if (addScopes && addScopes.length > 0) {
      scopesArray.push(addScopes.concat());
    }
  });
  scopesArray.push(requestedupdatedScopesArray.concat());
  const updatedScopesArray = [].concat.apply([], scopesArray);
  const uniqueScopeArray = updatedScopesArray.filter(function(scope, position) {
    return updatedScopesArray.indexOf(scope) === position;
  });
  const scopeString = uniqueScopeArray.join(' ');
  return scopeString;
}

export function handleScopeChange () {
  let routePath;
  let searchSting = "";
  const { search, hash, pathname } = useLocation();
  const postAuthorizeparams = getPostAuthorizeParams();
  if (Object.keys(postAuthorizeparams).length > 0) {
    return { routePath, search: searchSting, hash };
  } else {
    let updatedSearch;
    const searchParams = new URLSearchParams(search);
    const requestedScopes = searchParams.get('scope');
    if (requestedScopes) {
      const scopeStringRevised = addHTI1Scopes(requestedScopes);
      if (scopeStringRevised !== requestedScopes) {
        searchParams.delete('scope');
        searchParams.set('scope', scopeStringRevised);
        updatedSearch = new URLSearchParams(searchParams).toString();
        routePath = pathname;
      }
    }
    searchSting = updatedSearch ? updatedSearch : search;
    return { routePath, search: searchSting, hash };
  }
}
